<template>
  <div class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-flex ts-space-x-3">
    <p class="ts-mb-0">
      {{ $t('saleContract.fxKhrRate') }} :
      <span class="ts-font-extrabold ts-text-red-600">{{ khrRate }}</span>
    </p>
    <p class="ts-mb-0">
      {{ $t('saleContract.fxthbRate') }}:
      <span class="ts-font-extrabold ts-text-red-600" v-if="!edit_data.contract_id">{{ thbRate }}</span>
      <span class="ts-font-extrabold ts-text-red-600" v-else>
        {{ this.edit_data.fx_rate_thb }}
      </span>
    </p>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
export default {
  name: 'exchangeRate',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/saleContract', ['formViewData', 'edit_data']),
    khrRate() {
      if (this.formViewData.exchangeRate) {
        let foundFx = this.$store.state.wholesale.saleContract.formViewData.exchangeRate.find(
          e => e.to_currency == 'KHR'
        )
        if (foundFx) {
          return (this.model.fx_rate_khr = parseFloat(foundFx.fx_rate))
        }
      }
      return 0
    },
    thbRate() {
      if (this.formViewData.exchangeRate) {
        let foundFx = this.$store.state.wholesale.saleContract.formViewData.exchangeRate.find(
          e => e.to_currency == 'THB'
        )
        if (foundFx) {
          return (this.model.fx_rate_thb = parseFloat(foundFx.fx_rate))
        }
      }
      return (this.model.fx_rate_thb = 32)
    }
  }
}
</script>
